<template>
  <v-menu
    ref="menu"
    :close-on-content-click="false"
    v-model="modal"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    max-width="290px"
    min-width="290px"
  >
    <v-text-field
      slot="activator"
      :value="value"
      :label="label"
      readonly
    />
    <v-time-picker
      v-if="modal"
      :locale="locale"
      :value="value"
      :allowed-minutes="allowedMinutes"
      :allowed-hours="allowedHours"
      format="24hr"
      @input="save">
      <v-spacer/>
      <v-btn
        flat
        @click="modal = false">{{ $t('cancel') }}</v-btn>
      <v-btn
        color="primary"
        @click="$refs.menu.save(value)">{{ $t('ok') }}</v-btn>
    </v-time-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'TimePicker',
  props: ['value', 'label', 'errorMessages', 'rules', 'allowedHours', 'allowedMinutes'],
  data () {
    return {
      modal: false
    }
  },
  computed: {
    locale () {
      return `${localStorage.locale}-${localStorage.locale}`
    }
  },
  methods: {
    save (value) {
      this.$emit('input', value)
    }
  },
  i18n: {
    messages: {
      de: {
        cancel: 'Abbrechen',
        ok: 'Speichern'
      },
      en: {
        cancel: 'Cancel',
        ok: 'Ok'
      },
      tr: {
        cancel: 'İptal',
        ok: 'Tamam'
      },
      ru: {
        cancel: 'Отменить',
        ok: 'Сохранить'
      }
    }
  }
}
</script>
